import { workspaceConstants } from "../_constants";
import { workspaceServices } from "../_services";
import { alertActions } from ".";

export const workspaceActions = {
  getWorkspaceDetails,
  getAllActiveWorkspace,
  addWorkspace,
  editWorkspace,
  deleteWorkspace,
  getWorkspaceProps,
  applyFilters,
  searchWorkspaces
};

function getWorkspaceDetails(offset, limit) {
  return (dispatch) => {
    dispatch(request());
    workspaceServices.getWorkspaceDetails(offset, limit).then(
      (workspace) => dispatch(success(workspace)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: workspaceConstants.GET_WORKSPACE_DETAILS_REQUEST };
  }
  function success(workspace) {
    return {
      type: workspaceConstants.GET_WORKSPACE_DETAILS_SUCCESS,
      workspace,
    };
  }
  function failure(error) {
    return { type: workspaceConstants.GET_WORKSPACE_DETAILS_FAILURE, error };
  }
}

function getAllActiveWorkspace() {
  return (dispatch) => {
    dispatch(request());
    workspaceServices.getAllActiveWorkspace().then(
      (workspace) => dispatch(success(workspace)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: workspaceConstants.GET_ALL_ACTIVE_WORKSPACE_REQUEST };
  }
  function success(workspace) {
    return {
      type: workspaceConstants.GET_ALL_ACTIVE_WORKSPACE_SUCCESS,
      workspace,
    };
  }
  function failure(error) {
    return {
      type: workspaceConstants.GET_ALL_ACTIVE_WORKSPACE_FAILURE,
      error,
    };
  }
}

function addWorkspace(formData) {
  return (dispatch) => {
    dispatch(request());
    workspaceServices.addWorkspace(formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: workspaceConstants.CREATE_WORKSPACE_DETAILS_REQUEST };
  }
  function success(data) {
    return {
      type: workspaceConstants.CREATE_WORKSPACE_DETAILS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: workspaceConstants.CREATE_WORKSPACE_DETAILS_FAILURE,
      error,
    };
  }
}

function editWorkspace(formData) {
  return (dispatch) => {
    dispatch(request());
    workspaceServices.editWorkspace(formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: workspaceConstants.UPDATE_WORKSPACE_DETAILS_REQUEST };
  }
  function success(data) {
    return {
      type: workspaceConstants.UPDATE_WORKSPACE_DETAILS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: workspaceConstants.UPDATE_WORKSPACE_DETAILS_FAILURE,
      error,
    };
  }
}

function deleteWorkspace(workspaceId) {
  return (dispatch) => {
    dispatch(request());
    workspaceServices.deleteWorkspace(workspaceId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: workspaceConstants.DELETE_WORKSPACE_DETAILS_REQUEST };
  }
  function success(data) {
    return {
      type: workspaceConstants.DELETE_WORKSPACE_DETAILS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: workspaceConstants.DELETE_WORKSPACE_DETAILS_FAILURE,
      error,
    };
  }
}

function getWorkspaceProps() {
  return (dispatch) => {  
    dispatch(request());
    workspaceServices.getWorkspaceProps().then(
      (data) => dispatch(success(data)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  
  function request() {
    return { type: workspaceConstants.GET_WORKSPACE_PROPS_REQUEST };
  }
  function success(data) {
    return {
      type: workspaceConstants.GET_WORKSPACE_PROPS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: workspaceConstants.GET_WORKSPACE_PROPS_FAILURE,
      error,
    };
  }
}

function applyFilters(formData, offset, limit) {
  return (dispatch) => {
    dispatch(request());
    workspaceServices.applyFilters(formData, offset, limit).then(
      (data) => dispatch(success(data)),
      (error) => dispatch(failure(error.toString()))
    );
  };

 function request() {
    return { type: workspaceConstants.GET_WORKSPACE_DETAILS_REQUEST };
  }
  function success(workspace) {
    return {
      type: workspaceConstants.GET_WORKSPACE_DETAILS_SUCCESS,
      workspace,
    };
  }
  function failure(error) {
    return { type: workspaceConstants.GET_WORKSPACE_DETAILS_FAILURE, error };
  }
}

function searchWorkspaces(search, offset, limit) {
  return (dispatch) => {
    dispatch(request());
    workspaceServices.searchWorkspaces(search, offset, limit).then(
      (data) => dispatch(success(data)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: workspaceConstants.GET_WORKSPACE_DETAILS_REQUEST };
  }
  function success(workspace) {
    return {
      type: workspaceConstants.GET_WORKSPACE_DETAILS_SUCCESS,
      workspace,
    };
  }
  function failure(error) {
    return { type: workspaceConstants.GET_WORKSPACE_DETAILS_FAILURE, error };
  }
}
